import loadMore from './official/loadMore'

export default {
  loadMore
}